import { useState, useEffect } from 'react';

const MESSAGES_KEY = 'LathiNyx_messages';

function loadMessages() {
  try { return JSON.parse(localStorage.getItem(MESSAGES_KEY)) || []; } catch { return []; }
}

export default function Messages() {
  const [messages, setMessages] = useState(() => loadMessages());
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const refresh = () => setMessages(loadMessages());
    window.addEventListener('storage', refresh);
    const interval = setInterval(refresh, 3000);
    return () => { window.removeEventListener('storage', refresh); clearInterval(interval); };
  }, []);

  const deleteMsg = (id) => {
    const updated = messages.filter(m => m.id !== id);
    localStorage.setItem(MESSAGES_KEY, JSON.stringify(updated));
    setMessages(updated);
    if (selected?.id === id) setSelected(null);
  };

  const ST = { 'Web Development': 'tw', 'AI & ML Solutions': 'ta', 'Research Paper Services': 'tr-tag' };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 15, fontWeight: 700, color: '#111827' }}>Contact Messages</div>
          <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>Messages submitted via the website contact form</div>
        </div>
        <span style={{ fontSize: 12, color: '#6b7280' }}>Total: <b style={{ color: '#111827' }}>{messages.length}</b></span>
      </div>

      {messages.length === 0 ? (
        <div className="d-card" style={{ textAlign: 'center', padding: 48 }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>📭</div>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 6 }}>No messages yet</div>
          <div style={{ fontSize: 13, color: '#9ca3af' }}>Messages from the website contact form will appear here.</div>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: selected ? '1fr 1.4fr' : '1fr', gap: 16 }}>
          <div>
            {messages.map(m => (
              <div key={m.id}
                onClick={() => setSelected(m)}
                style={{ background: '#fff', border: '1px solid ' + (selected?.id === m.id ? '#2563eb' : '#e5e7eb'), borderRadius: 8, padding: '14px 16px', marginBottom: 8, cursor: 'pointer', transition: 'border-color 0.12s' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 13, color: '#111827' }}>{m.name}</div>
                    <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>{m.email}</div>
                    <div style={{ marginTop: 6, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                      <span className={'d-tag ' + (ST[m.service] || 'tw')} style={{ fontSize: 10 }}>{m.service}</span>
                      <span style={{ fontSize: 10, color: '#6b7280' }}>{m.budget}</span>
                    </div>
                    <div style={{ fontSize: 12, color: '#374151', marginTop: 6, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 280 }}>{m.message}</div>
                  </div>
                  <div style={{ textAlign: 'right', flexShrink: 0, marginLeft: 12 }}>
                    <div style={{ fontSize: 10, color: '#9ca3af' }}>{m.receivedAt}</div>
                    <button className="d-btn d-btn-sm" style={{ color: '#e11d48', borderColor: '#fecdd3', padding: '3px 8px', marginTop: 6, fontSize: 11 }} onClick={e => { e.stopPropagation(); deleteMsg(m.id); }}>Delete</button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {selected && (
            <div className="d-card" style={{ position: 'sticky', top: 80, alignSelf: 'start' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>Message Detail</div>
                <span style={{ cursor: 'pointer', color: '#9ca3af', fontSize: 20 }} onClick={() => setSelected(null)}>&times;</span>
              </div>
              <div style={{ display: 'grid', gap: 10 }}>
                {[['Name', selected.name], ['Email', selected.email], ['Service', selected.service], ['Budget', selected.budget], ['Received', selected.receivedAt]].map(([l, v]) => (
                  <div key={l} style={{ background: '#f9fafb', borderRadius: 6, padding: '8px 12px', border: '1px solid #e5e7eb' }}>
                    <div style={{ fontSize: 10, color: '#6b7280', marginBottom: 2 }}>{l}</div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#111827' }}>{v}</div>
                  </div>
                ))}
                <div style={{ background: '#f9fafb', borderRadius: 6, padding: '10px 12px', border: '1px solid #e5e7eb' }}>
                  <div style={{ fontSize: 10, color: '#6b7280', marginBottom: 6 }}>Message</div>
                  <div style={{ fontSize: 13, color: '#111827', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{selected.message}</div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
                <a href={'mailto:' + selected.email} className="d-btn d-btn-primary" style={{ flex: 1, textAlign: 'center', textDecoration: 'none', fontSize: 13 }}>Reply via Email</a>
                <button className="d-btn" style={{ color: '#e11d48', borderColor: '#fecdd3' }} onClick={() => deleteMsg(selected.id)}>Delete</button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
